<template>
  <h1 class="fs-28 fw-medium color-heading fs-sm-20">
    {{ getTitle }}
  </h1>
</template>

<script>
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { mapState } from "pinia";

export default {
  name: "ColorProductName",
  computed: {
    ...mapState(useProductStore, ["getTitle"]),
  },
};
</script>
